import type { NavigationRoutingObject } from "@navigationRouting/types";

import { hasBannerTemplatePermissions } from "@services/useBannerTemplatePermissions/hasBannerTemplatePermissions";

import { bannerTemplateDetailsNRO } from "../__templateId";

export const bannerTemplateCreateNRO: NavigationRoutingObject = {
  ...bannerTemplateDetailsNRO,
  getDeveloperNavigationAllowed: (payload) => {
    const { canEditBannerTemplates } = hasBannerTemplatePermissions(payload);

    return bannerTemplateDetailsNRO.getDeveloperNavigationAllowed(payload) && canEditBannerTemplates;
  },
};
